(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
  const { Section } = window.PxuThemeSections;

  class VideoBannerSection extends Section {
    constructor($root) {
      super($root);
      this.$root = $root;
      this.$videos = this.$root.querySelectorAll('.pxu-video-banner__video');
      this.id = $root.id;
      this.data = this.loadData();
      this.observer = null;
      this.mobileBreakpoint = 798;
      this.hasDualVideos = this.$videos.length > 1;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isInView = false;
      this.resizeHandler = null;

      this.onMount();
    }

    onMount() {
      // Ensure all videos have muted property set and controls disabled (Chrome fixes)
      this.$videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        // Ensure attributes are present on the element as some browsers require
        // the HTML attribute (not just the JS property) for autoplay to work.
        try {
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
        } catch (e) {}
        video.removeAttribute('controls');
      });

      this.initIntersectionObserver();

      if (this.hasDualVideos) {
        this.resizeHandler = this.debounce(() => {
          if (this.isInView) {
            this.handleVideoPlayback();
          }
        }, 150);
        window.addEventListener('resize', this.resizeHandler);
      }
    }

    onUnmount() {
      if (this.observer) {
        this.observer.unobserve(this.$root);
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
      this.$videos.forEach((video) => video.pause());
    }

    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isInView = true;
              this.handleVideoPlayback();
              observer.unobserve(this.$root);
            }
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this.$root);
    }

    getActiveVideo() {
      if (!this.hasDualVideos) {
        return this.$videos[0] || null;
      }

      const isMobile = window.innerWidth <= this.mobileBreakpoint;
      const desktopVideo = this.query('.pxu-video-banner__video--desktop');
      const mobileVideo = this.query('.pxu-video-banner__video--mobile');

      return isMobile ? mobileVideo : desktopVideo;
    }

    handleVideoPlayback() {
      if (this.prefersReducedMotion) {
        this.$videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.setAttribute('controls', '');
        });
        return;
      }

      const activeVideo = this.getActiveVideo();
      if (!activeVideo) return;

      // Pause all videos first
      this.$videos.forEach((video) => {
        if (!video.paused) {
          video.pause();
        }
      });

      // Ensure muted is set as property and controls are removed (Chrome fix)
      activeVideo.muted = true;
      activeVideo.removeAttribute('controls');
      try {
        activeVideo.setAttribute('muted', '');
        activeVideo.setAttribute('playsinline', '');
        activeVideo.setAttribute('webkit-playsinline', '');
      } catch (e) {}

      // Wait for video to be ready before playing
      if (activeVideo.readyState >= 2) {
        this.playVideo(activeVideo);
      } else {
        activeVideo.addEventListener('loadeddata', () => {
          this.playVideo(activeVideo);
        }, { once: true });
      }
    }

    playVideo(video) {
      video.muted = true;
      video.removeAttribute('controls');
      try {
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        // Setting the autoplay attribute before calling play can help some browsers
        // that gate autoplay behavior on the presence of the attribute.
        video.setAttribute('autoplay', '');
      } catch (e) {}

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn('Video autoplay was prevented:', error.name, error.message);
          if (error.name === 'NotAllowedError') {
            this.handleAutoplayBlocked(video);
          }
        });
      }
    }

    handleAutoplayBlocked(video) {
      // Fallback: start playback on first user interaction
      const playOnInteraction = () => {
        video.muted = true;
        video.play().catch(() => {});
        document.removeEventListener('click', playOnInteraction);
        document.removeEventListener('touchstart', playOnInteraction);
      };

      document.addEventListener('click', playOnInteraction, { once: true });
      document.addEventListener('touchstart', playOnInteraction, { once: true });
    }

    debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
    Section.init($section, VideoBannerSection);
  });

  if (Shopify.designMode) {
    window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
  }

  } catch(e) { console.error(e); }
})();
})();
